// extracted by mini-css-extract-plugin
export default {"custom-modal-backdrop":"Modal_custom-modal-backdrop__xdw1m","custom-modal":"Modal_custom-modal__w-izX","customModalFade":"Modal_customModalFade__brfzI"};